// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"369":"943d470b","736":"0ac9e1c9"}[chunkId] + ".chunk.css";
};